import { render, staticRenderFns } from "./IopsSelector.vue?vue&type=template&id=b8345c76&"
import script from "./IopsSelector.vue?vue&type=script&lang=js&"
export * from "./IopsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8345c76')) {
      api.createRecord('b8345c76', component.options)
    } else {
      api.reload('b8345c76', component.options)
    }
    module.hot.accept("./IopsSelector.vue?vue&type=template&id=b8345c76&", function () {
      api.rerender('b8345c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/launchService/IopsSelector.vue"
export default component.exports